export const notBlankValidation = {
  required: {
    value: true,
    message: "Це поле є обов'язковим",
  },
  maxLength: {
    value: 255,
    message: 'Перевищено ліміт символів 255',
  },
};

export const textLimitValidation = {
  maxLength: {
    value: 255,
    message: 'Перевищено ліміт символів 255',
  },
};

export const vinValidation = {
  required: {
    value: true,
    message: "Це поле є обов'язковим",
  },
  pattern: {
    value: /^[A-HJ-NPR-Z\d]{17}$/,
    message: 'Некоректний VIN код',
  },
};

export const yearValidation = {
  min: {
    value: 1900,
    message: 'Рік має бути більше ніж 1900',
  },
  max: {
    value: 9999,
    message: 'Рік має бути менше ніж 9999',
  },
};

export const commentLimitValidation = {
  maxLength: {
    value: 99999,
    message: 'Перевищено ліміт символів коментару 99999',
  },
};

export const mileageValidation = {
  min: {
    value: 1,
    message: 'Пробіг має некоректне значення',
  },
  max: {
    value: 9999999,
    message: 'Перевищено ліміт пробігу 9999999',
  },
};

export const passwordValidation = {
  required: {
    value: true,
    message: "Це поле є обов'язковим",
  },
  minLength: {
    value: 4,
    message: 'Пароль має містити не менше 4 символи',
  },
  maxLength: {
    value: 100,
    message: 'Перевищено ліміт символів 100',
  },
};

export const phoneValidation = {
  required: {
    value: true,
    message: "Це поле є обов'язковим",
  },
  pattern: {
    value: /^(?:\+38)?(0\d{9})$/,
    message: 'Телефон має бути у форматі: +380976543210',
  },
};

export const priceValidation = {
  required: {
    value: true,
    message: "Це поле є обов'язковим",
  },
  validate: {
    validateMaxPrice: (value) => parseFloat(value) <= 9999999.99 || 'Ціна не має перевищувати 999 999.99',
  },
  min: {
    value: 0,
    message: 'Ціна має некоректне значення',
  },
  pattern: {
    value: /^\d+(\.\d{1,2})?$/,
    message: 'Ціна має некоректне значення',
  },
};

export const partCountValidation = {
  required: {
    value: true,
    message: "Це поле є обов'язковим",
  },
  validate: {
    validateMaxCount: (value) => parseFloat(value) <= 999999.99 || 'Кількість не має перевищувати 99 999.99',
  },
  min: {
    value: 0,
    message: 'Кількість має некоректне значення',
  },
  pattern: {
    value: /^\d+(\.\d{1,2})?$/,
    message: 'Кількість має некоректне значення',
  },
};

export const engineValidation = {
  min: {
    value: 0.1,
    message: "Об'єм двигуна має некоректне значення",
  },
  validate: {
    validateMaxEngine: (value) =>
      value ? parseFloat(value) <= 999.9 || "Об'єм двигуна не має перевищувати 999.9" : true,
  },
  pattern: {
    value: /^\d+(\.\d{1})?$/,
    message: "Об'єм двигуна має некоректне значення",
  },
};

export const hourValidation = {
  required: {
    value: true,
    message: "Це поле є обов'язковим",
  },
  min: {
    value: 0,
    message: 'Нормо-година має некоректне значення',
  },
  validate: {
    validateMaxHour: (value) => parseFloat(value) <= 999.9 || 'Нормо-година не має перевищувати 999.9',
  },
  pattern: {
    value: /^\d+(\.\d{1})?$/,
    message: 'Нормо-година має некоректне значення',
  },
};

export const emptyRolesValidation = {
  required: 'Виберіть хоча б одну роль користувача',
};
